import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPorts,removePort } from "../features/ports/portSlice";
import { API_URL } from "../config";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

function PortTable() {

    const dispatch = useDispatch();

    const { ports } = useSelector(
        (state) => state.ports
    );

    const [filterText, setFilterText] = useState("");

    const deletePort = async (id) => {

        const result = await Swal.fire({
            title: "Delete Port?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {

            await dispatch(removePort(id)).unwrap();

            toast.success("Port deleted successfully.");

        } catch (error) {

            toast.error(error || "Delete failed.");

        }

    };

    const filteredItems = ports.filter((item) =>
        (item.name || "")
            .toLowerCase()
            .includes(filterText.toLowerCase())
    );
    const totalOpeningBalance = ports.reduce(
    (total, item) => total + (Number(item.opening_balance) || 0),
    0
);

    const columns = [

        {
            name: "#",
            width: "70px",
            cell: (row, index) => index + 1
        },

        {
            name: "Name",
            selector: row => row.name,
            sortable: true
        },

        {
            name: "Opening Balance",
            selector: row => row.opening_balance,
            sortable: true
        },

        {
            name: "Action",
            width: "130px",
            cell: (row) => (

                <div className="dropdown">

                    <button
                        className="btn btn-primary btn-sm dropdown-toggle"
                        data-bs-toggle="dropdown"
                    >
                        Actions
                    </button>

                    <ul className="dropdown-menu">

                        <li>

                            <Link
                                className="dropdown-item"
                                to={`/dashboard/editport/${row._id}`}
                            >
                                <i className="bi bi-pencil-square me-2"></i>
                                Edit
                            </Link>

                        </li>

                        <li>

                            <Link
                                className="dropdown-item"
                                to={`/dashboard/port/${row._id}`}
                            >
                                <i className="bi bi-eye me-2"></i>
                                View
                            </Link>

                        </li>

                        <li>
                            <hr className="dropdown-divider" />
                        </li>

                        <li>

                            <button
                                className="dropdown-item text-danger"
                                onClick={() => deletePort(row._id)}
                            >
                                <i className="bi bi-trash me-2"></i>
                                Delete
                            </button>

                        </li>

                    </ul>

                </div>

            )
        }

    ];

    return (

        <div className="card shadow border-0">

            <div className="card-header bg-success text-white d-flex justify-content-between">

                <h5 className="mb-0">

                    <i className="bi bi-people-fill me-2"></i>

                    Buyer List

                </h5>

                <span className="badge bg-light text-dark">

                    Total : {ports.length}

                </span>
                <span className="badge bg-warning text-dark fs-6">
            Opening Balance: ₹{totalOpeningBalance.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}
        </span>

            </div>

            <div className="card-body">

                <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search Buyer..."
                    value={filterText}
                    onChange={(e) =>
                        setFilterText(e.target.value)
                    }
                />

                <DataTable
                    columns={columns}
                    data={filteredItems}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10,20,50]}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="500px"
                    persistTableHead
                    noDataComponent="No Port Found"
                />

            </div>

        </div>

    );

}

export default PortTable;